import moment from 'moment';

export const EDITABLE_COURSE_FIELDS = [
    'name',
    'course_id',
    'course_type',
    'provider',
    'link',
    'status',
    'category',
    'language',
    'level',
    'skill_level',
    'domain',
    'duration',
    'popular',
    'e_commerce',
    'my_players',
    'description',
    'long_description',
    'course_overview',
    'key_features',
    'skills_covered',
    'benefits',
    'eligibility',
];

export const READ_ONLY_COURSE_FIELDS = [
    'course_id_moodle',
    'course_id_talent_lms',
    'external_id',
    'version',
    'is_moodle',
    'created_at',
    'updated_at',
    'creation_date',
    'last_update_on',
];

export const createEmptyCourseForm = () => EDITABLE_COURSE_FIELDS.reduce((form, field) => {
    form[field] = '';
    return form;
}, {});

export const mapCourseToForm = (course = {}) => EDITABLE_COURSE_FIELDS.reduce((form, field) => {
    form[field] = course[field] == null ? '' : course[field];
    return form;
}, {});

export const mapReadOnlyCourseFields = (course = {}) => READ_ONLY_COURSE_FIELDS.reduce((details, field) => {
    details[field] = course[field];
    return details;
}, {});

export const buildCoursePayload = (formState, imageDataUrl = '') => {
    const payload = EDITABLE_COURSE_FIELDS.reduce((editable, field) => {
        editable[field] = formState[field];
        return editable;
    }, {});

    if (/^data:image\/(?:jpeg|png);base64,/i.test(imageDataUrl)) {
        payload.image = imageDataUrl;
    }

    return payload;
};

export const getCourseThumbnail = (course = {}) => (
    course.thumbnail || course.thumbnail_url || course.imageUrl || ''
);

export const getCourseDescription = (course = {}) => (
    course.description || course.description_excerpt || ''
);

export const getCourseName = (course = {}) => (
    typeof course.name === 'string' ? course.name.trimStart() : (course.name || '')
);

export const formatCourseCreatedDate = (value) => {
    if (!value) return '—';
    const parsed = moment(value, moment.ISO_8601, true);
    return parsed.isValid() ? parsed.format('DD MMM YYYY') : '—';
};

export const truncateCourseUrl = (value, limit = 34) => {
    if (!value) return '';
    if (value.length <= limit) return value;
    return `${value.slice(0, limit - 1)}…`;
};

export const withCourseImageCacheBust = (url, updatedAt) => {
    if (!url || !/^https?:\/\//i.test(url) || !updatedAt) return url || '';
    return `${url}${url.includes('?') ? '&' : '?'}t=${encodeURIComponent(updatedAt)}`;
};

export const getResponseCourse = (result = {}) => {
    if (Array.isArray(result.data)) return result.data[0] || null;
    if (result.data && typeof result.data === 'object') return result.data;
    return null;
};
